import type { IntlShape } from 'react-intl';

import type { ViewMode } from '@atlaskit/editor-plugin-editor-viewmode/editorViewmodePluginType';
import type { PlaceholderPluginOptions } from '@atlaskit/editor-plugin-placeholder/placeholder-plugin-type';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/editor-experiment';

import { i18n } from './i18n';

interface Props {
	intl: IntlShape;
	options: {
		isAIEnabled: boolean;
		viewMode: ViewMode | undefined;
	};
}

export function placeholderPluginOptions({ intl, options }: Props): PlaceholderPluginOptions {
	const placeholder = (() => {
		if (options.viewMode === 'view') {
			return undefined;
		}

		if (!options.isAIEnabled) {
			return intl.formatMessage(i18n.defaultPlaceholder);
		}

		if (editorExperiment('platform_editor_controls', 'variant1')) {
			return intl.formatMessage(i18n.defaultPlaceholder);
		}

		return intl.formatMessage(i18n.easyCommandsPlaceholder);
	})();

	return {
		placeholder,
	};
}
